import { InjectionToken } from '@angular/core';

/**
 * API base URL for the company endpoints, supplied by the hosting app.
 *
 * The two portals resolve their base differently — the main portal from its `ConfigService`
 * (assets/config.json), the Phoenix portal from `ShellConfigService` — and neither service can
 * live in this library without dragging one app's config machinery into the other. A token
 * inverts that: the library states what it needs, each app provides it once at bootstrap.
 *
 * Expected value: the API root WITHOUT a trailing slash, e.g. `https://localhost:7145/api`.
 */
export const COMPANY_API_BASE_URL = new InjectionToken<string>('COMPANY_API_BASE_URL');

/**
 * Non-production host detection for dev-only affordances (the DEV quick-upgrade button).
 *
 * Hostname-based on purpose, mirroring the main portal's `EnvironmentService.isDevelopment`:
 * the deployed dev/test apps are PRODUCTION builds, so `environment.production` would hide the
 * button exactly where it is needed. Pure function so it is testable and app-independent.
 */
export function isNonProductionHost(hostname: string): boolean {
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '[::1]' ||
    hostname.includes('dev.continity') ||
    hostname.includes('.dev.')
  );
}
